export { default as InventarioInicial } from "./InventarioInicial";
